export const LOCALE_SET = 'localization/LOCALE_SET';
export const INTEL_LOCALE_SET = 'localization/INTEL_LOCALE_SET';
export const INTEL_LOCALE_RESET = 'localization/INTEL_LOCALE_RESET';
